<template>
	<div>
		<Top></Top>
		<div class="wd-container ascss">
			<div class="wd-m-t-20"></div>
			<div class="rowtitle">订单商品</div>
			<div class="rowvalue wd-flex wd-row-left">
				<div class="wd-goods-img-thumbnail wd-row-noshrink"><el-image :src="$wdpicurl(wddataitem.pic1)"></el-image></div>
				<div class="wd-row-grow wd-m-l-20">
					<div>{{ wddataitem.name }}</div>
					<div class="wd-m-t-10">{{ wddataitem.spec }}</div>
					<div class="wd-m-t-10">
						<span class="wd-theme">¥{{ price1 | amountFormatter }}</span>
						<span class="wd-theme-666 wd-m-l-20">× {{ buynum }}</span>
					</div>
				</div>
			</div>
			<div class="rowtitle">申请服务</div>
			<div class="rowvalue">
				<el-radio-group v-model="type" @change="selecttype">
					<el-radio :label="0">
						申请补偿
						<span class="wd-theme-999 wd-font-12">(已收到货，需要申请补偿)</span>
					</el-radio>
					<el-radio :label="1">
						仅退款
						<span class="wd-theme-999 wd-font-12">(未收到货，申请退款)</span>
					</el-radio>
					<el-radio :label="2">
						退货退款
						<span class="wd-theme-999 wd-font-12">(已收到货，需申请退货退款)</span>
					</el-radio>
				</el-radio-group>
			</div>
			<div class="rowvalue"></div>
			<div class="rowvalue wd-theme-999">
				<span class="wd-m-r-20">服务说明:</span>
				<span v-if="type == 0">对于收到的货物不满意，不退货，申请补偿</span>
				<span v-else-if="type == 1">未收到的货或货不全，申请退款</span>
				<span v-else-if="type == 2">已收到货，需要退还收到的货物</span>
			</div>
			<div class="rowtitle">退款原因</div>
			<div class="rowvalue">
				<el-select v-model="reason" placeholder="请选择退款原因" style="width: 400px;">
					<el-option v-for="item in reasonarray" :key="item" :label="item" :value="item"></el-option>
				</el-select>
			</div>
			<div class="rowtitle">损坏程度</div>
			<div v-if="type == 0">
				<div class="rowvalue wd-flex wd-row-left">
					<div class="span">轻微破损，不影响使用</div>
					<el-input-number v-model="num1" :min="0" @change="addnum(1, 1)" :max="buynum" label="请选择数量"></el-input-number>
				</div>
				<div class="rowvalue wd-flex wd-row-left">
					<div class="span">中度破损，影响使用</div>
					<el-input-number v-model="num2" :min="0" @change="addnum(1, 1)" :max="buynum" label="请选择数量"></el-input-number>
				</div>
				<div class="rowvalue wd-flex wd-row-left">
					<div class="span">严重破损，严重影响使用</div>
					<el-input-number v-model="num3" :min="0" @change="addnum(1, 3)" :max="buynum" label="请选择数量"></el-input-number>
				</div>
			</div>
			<div v-else class="rowvalue wd-flex wd-row-left">
				<div class="span">退货数量</div>
				<el-input-number v-model="num" :min="0" @change="addnum(1, 0)" :max="buynum" label="请选择数量"></el-input-number>
			</div>
			<div v-if="type == 0" class="rowvalue wd-flex wd-row-left">
				<div class="span">请输入申请退款金额</div>
				<div class="span"><el-input v-model="amount" :min="0" :max="buyamount" type="number" label="请输入申请退款的金额"></el-input></div>
			</div>
			<div v-else class="rowvalue wd-flex wd-row-left">
				<div class="span">退款金额</div>
				<div class="wd-theme wd-font-26">¥{{ amount }}</div>
			</div>
			<div class="rowvalue">
				<span class="wd-theme-999">点击查看</span>
				<span class="wd-theme wd-cursor">退款金额标准</span>
			</div>
			<div class="rowtitle">上传凭证(请根据提示要求上传图片，否则无法处理售后影响您的退款)</div>
			<div class="rowvalue">
				<div>
					1.收货的快递单面照
					<el-upload
						class="avatar-uploader"
						action="#"
						:multiple="false"
						:limit="limitpic"
						:show-file-list="false"
						:http-request="param => aupimg(param, 1)"
						:on-preview="file => aimgpreview(file, 1)"
						accept="image/jpeg,image/png,image/jpg"
					>
						<img v-if="pic1url" :src="$wdpicurl(pic1url)" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</div>
			</div>
			<div class="rowvalue">
				2.快递外箱照片
				<el-upload
					class="avatar-uploader"
					action="#"
					:multiple="false"
					:limit="limitpic"
					:show-file-list="false"
					:http-request="param => aupimg(param, 2)"
					:on-preview="file => aimgpreview(file, 2)"
					accept="image/jpeg,image/png,image/jpg"
				>
					<img v-if="pic2url" :src="$wdpicurl(pic2url)" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div class="rowvalue">
				3.产品正面照
				<el-upload
					class="avatar-uploader"
					action="#"
					:multiple="false"
					:limit="limitpic"
					:show-file-list="false"
					:http-request="param => aupimg(param, 3)"
					:on-preview="file => aimgpreview(file, 3)"
					accept="image/jpeg,image/png,image/jpg"
				>
					<img v-if="pic3url" :src="$wdpicurl(pic3url)" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div class="rowvalue">
				4.产品批次号和效期处照片
				<el-upload
					class="avatar-uploader"
					action="#"
					:multiple="false"
					:limit="limitpic"
					:show-file-list="false"
					:http-request="param => aupimg(param, 4)"
					:on-preview="file => aimgpreview(file, 4)"
					accept="image/jpeg,image/png,image/jpg"
				>
					<img v-if="pic4url" :src="$wdpicurl(pic4url)" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div class="rowvalue">
				5.溯源二维码照片（如包装上有二维码必填）
				<el-upload
					class="avatar-uploader"
					action="#"
					:multiple="false"
					:limit="limitpic"
					:show-file-list="false"
					:http-request="param => aupimg(param, 5)"
					:on-preview="file => aimgpreview(file, 5)"
					accept="image/jpeg,image/png,image/jpg"
				>
					<img v-if="pic5url" :src="$wdpicurl(pic5url)" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div class="rowvalue">
				6.产品与快递面单合照
				<el-upload
					class="avatar-uploader"
					action="#"
					:multiple="false"
					:limit="limitpic"
					:show-file-list="false"
					:http-request="param => aupimg(param, 6)"
					:on-preview="file => aimgpreview(file, 6)"
					accept="image/jpeg,image/png,image/jpg"
				>
					<img v-if="pic6url" :src="$wdpicurl(pic6url)" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div class="rowtitle">申请说明</div>
			<div class="rowvalue">
				<el-input type="textarea" placeholder="请填写售后申请说明" v-model="memo" maxlength="200" show-word-limit :autosize="{ minRows: 4, maxRows: 8 }"></el-input>
			</div>
			<div class="btngroup">
				<el-button @click="cancle" type="info" plain>取消退款</el-button>
				<el-button @click="save" type="primary" class="wd-p-l-30 wd-p-r-30 wd-m-l-50">提交</el-button>
			</div>
		</div>
		<Footer></Footer>
		<el-dialog :visible.sync="dialogVisible2"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
	</div>
</template>

<script>
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Afterserviceedit',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			posid: '',
			listseqno: '',
			detailid: '',
			wddataitem: '',
			limitpic: 1,
			type: 0,
			type0: 0,
			memo: '',
			price1: 0,
			num: 0,
			buynum: 0,
			buyamount: 0,
			servicenum: 0,
			amount: 0,
			num1: 0,
			num2: 0,
			num3: 0,
			reason: '',
			reasonarray: ['商品包装破损', '物流原因破损', '商品发错', '商品生产日期不合适', '无理由退货', '外观脏污', '其他质量问题'],
			index: 0,
			pic1: '',
			pic1url: '',
			pic2: '',
			pic2url: '',
			pic3: '',
			pic3url: '',
			pic4: '',
			pic4url: '',
			pic5: '',
			pic5url: '',
			pic6: '',
			pic6url: '',
			dialogVisible2: false,
			dialogImageUrl: ''
		};
	},
	activated() {
		var e = this.$route.query || '';
		this.detailid = e.detailid;
		this.$wd_request('afterservicegoods', { detailid: this.detailid })
			.then(data => {
				this.wddataitem = data.value;
				this.buynum = parseInt(data.value.num);
				this.buyamount = parseFloat(data.value.realamount);
				this.servicenum = data.value.servicenum;
				this.price1 = data.value.price1;
			})
			.catch(() => {});
	},
	methods: {
		selecttype(e) {
			console.log(e);
			this.num1 = 0;
			this.num2 = 0;
			this.num3 = 0;
			this.num = 0;
		},
		aupimg(param, index) {
			var file = param.file;
			var that = this;
			this.$wdupimg(file)
				.then(data => {
					if (index == 1) {
						that.pic1url = data.url;
						that.pic1 = data.value;
					} else if (index == 2) {
						that.pic2url = data.url;
						that.pic2 = data.value;
					} else if (index == 3) {
						that.pic3url = data.url;
						that.pic3 = data.value;
					} else if (index == 4) {
						that.pic4url = data.url;
						that.pic4 = data.value;
					} else if (index == 5) {
						that.pic5url = data.url;
						that.pic5 = data.value;
					} else if (index == 6) {
						that.pic6url = data.url;
						that.pic6 = data.value;
					}
				})
				.catch(() => {});
		},
		aimgpreview(f, idx) {
			switch (idx) {
				case 1:
					this.dialogImageUrl = this.pic1url;
					break;
				case 2:
					this.dialogImageUrl = this.pic2url;
					break;
				case 3:
					this.dialogImageUrl = this.pic3url;
					break;
				case 4:
					this.dialogImageUrl = this.pic4url;
					break;
				case 5:
					this.dialogImageUrl = this.pic5url;
					break;
				case 6:
					this.dialogImageUrl = this.pic6url;
					break;
				default:
					return;
			}
			console.log('preview');

			this.dialogVisible2 = true;
		},
		addnum(num, flag) {
			let nownum = 0;
			if (flag == 1) {
				nownum = this.num1;
			} else if (flag == 2) {
				nownum = this.num2;
			} else if (flag == 3) {
				nownum = this.num3;
			} else if (flag == 0) {
				nownum = this.num;
			}
			// if (num < 0) {
			// 	nownum = nownum + num;
			// 	if (nownum < 0) {
			// 		nownum = 0;
			// 	}
			// } else {
			// 	nownum = nownum + num;
			// }
			// if (flag == 0) {
			// 	if (nownum > this.buynum) {
			// 		nownum = this.buynum;
			// 	}
			// } else {
			// 	if (this.num1 + this.num2 + this.num3 + num > this.buynum) {
			// 		nownum = nownum - num;
			// 	}
			// }
			if (flag == 1) {
				this.num1 = nownum;
				this.num = this.num1 + this.num2 + this.num3;
			} else if (flag == 2) {
				this.num2 = nownum;
				this.num = this.num1 + this.num2 + this.num3;
			} else if (flag == 3) {
				this.num3 = nownum;
				this.num = this.num1 + this.num2 + this.num3;
			} else if (flag == 0) {
				this.num = nownum;
				this.amount = this.num * this.price1;
			}
		},
		save() {
			if (this.$weidajs.isEmpty(this.reason)) {
				this.$wd_toast('请选择退款原因', 'error');
				return;
			}
			if (parseInt(this.num) === 0) {
				this.$wd_toast('请输入退款数量', 'error');
				return;
			}
			if (parseInt(this.num) > parseInt(this.buynum)) {
				this.$wd_toast('申请退款数量不能大于购买数量', 'error');
				return;
			}
			// if (this.pic1==""){
			// 	this.$wd_toast("请上传收货的快递单面照");
			// 	return;
			// }
			// if (this.pic2==""){
			// 	this.$wd_toast("请上传快递外箱照片");
			// 	return;
			// }
			// if (this.pic3==""){
			// 	this.$wd_toast("请上传产品正面照");
			// 	return;
			// }
			// if (this.pic4==""){
			// 	this.$wd_toast("请上传产品批次号和效期处照片");
			// 	return;
			// }
			// if (this.pic5==""){
			// 	this.$wd_toast("请上传溯源二维码照片");
			// 	return;
			// }
			// if (this.pic6==""){
			// 	this.$wd_toast("请上传产品与快递面单合照");
			// 	return;
			// }
			if (this.memo == '') {
				this.$wd_toast('请填写申请说明', 'error');
			}
			var indata = {
				detailid: this.detailid,
				flag: this.type,
				memo: this.memo,
				pic1: this.pic1,
				pic2: this.pic2,
				pic3: this.pic3,
				pic4: this.pic4,
				pic5: this.pic5,
				pic6: this.pic6,
				reason: this.reason,
				num: this.num,
				num1: this.num1,
				num2: this.num2,
				num3: this.num3,
				amount: this.amount,
				branchid: this.wddataitem.branchid
			};
			this.$wd_request('afterserviceopt', indata)
				.then(() => {
					this.$wd_msg('保存成功');
					this.$router.go(-1);
				})
				.catch(data => {
					this.$wd_toast(data.msg, 'error');
				});
		},
		cancle() {}
	}
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
	width: 68px;
	height: 68px;
	line-height: 68px;
	display: block;
	margin-top: 10px;
	border: 1px dashed #8c939d;
	.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.el-upload:hover {
		border-color: #409eff;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 68px;
		height: 68px;
		line-height: 68px;
		text-align: center;
	}
	.avatar {
		width: 68px;
		height: 68px;
		line-height: 68px;
		display: block;
	}
}

.ascss {
	width: 800px;
	.rowtitle {
		border-left: 4px solid $wd-theme;
		padding-left: 10px;
		margin: 10px 0;
	}
	.rowvalue {
		margin: 10px 0;
		padding-left: 44px;
		.span {
			width: 200px;
		}
	}
	.btngroup {
		padding-left: 280px;
		margin-top: 30px;
	}
}
</style>
